import { createReducer, on } from '@ngrx/store';
import { initialState } from './error.state';
import { ErrorActions } from './error.actions';

export const reducer = createReducer(
	initialState,
	on(ErrorActions.error.show, (state, { payload }) => ({
		...state,
		message:
			typeof payload.message === 'string'
				? payload.message
				: 'An error occurred. Please try again.',
	})),
	on(ErrorActions.error.hide, (state) => ({
		...state,
		message: undefined,
	}))
);
